import { AuditSchedule, MinimumAuditMatch, Seconds } from '@mi-front/core';
import { Chip, Duration, Info, ResultsCount, Table } from '@mi-front/ui';
import { Box, Grid } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { LDate } from '../../../../components/date/LDate';
import { LTime } from '../../../../components/date/LTime';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly data: {
    readonly station: Station;
    readonly schedule: AuditSchedule;
  };
}

export function SchedulesViewViewP(p: Props) {
  const { $t } = useIntl();
  const { schedule } = p.data;

  return (
    <div>
      <div className="d-flex align-items-center">
        <div className="flex-grow-1">
          <Grid container sx={{ mb: 2 }}>
            <Grid item xs={12} md={9}>
              <div className="mb-4">
                <Info
                  title={
                    <FormattedMessage
                      id="audit.props.datetime"
                      defaultMessage="Fecha y hora programada"
                    />
                  }
                  data={
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <LDate
                        value={schedule.datetime}
                        day="2-digit"
                        month="2-digit"
                        year="2-digit"
                      />
                      <LTime value={schedule.datetime} />
                    </div>
                  }
                />
              </div>
              <div className="mb-4">
                <Info
                  title={<FormattedMessage id="audit.props.customId" defaultMessage="Custom ID" />}
                  data={schedule.customId}
                />
              </div>
              <div className="mb-4">
                <Info
                  title={
                    <FormattedMessage
                      id="audit.props.tolerance"
                      defaultMessage="Tolerancia (mins)"
                    />
                  }
                  data={schedule.tolerance}
                />
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Info
                title={<FormattedMessage id="audit.props.matches" defaultMessage="Matches" />}
                data={
                  <>
                    <ResultsCount count={schedule.matches?.length || 0}>
                      <FormattedMessage
                        id="audit.schedulesViewScreen.matchesCount"
                        defaultMessage={`
        {count, plural,
          =0 {No hay matches aún}
          one {1 match}
          other {# matches}
        }
      `}
                        values={{ count: schedule.matches?.length || 0 }}
                      />
                    </ResultsCount>
                    {schedule.matches && schedule.matches.length > 0 && (
                      <Box component="div" data-cy="matches-table">
                        <Table
                          columns={[
                            {
                              Header: $t({
                                id: 'audit.schedulesViewScreen.matchTime',
                                defaultMessage: 'Fecha y hora',
                              }),
                              align: 'center',
                              w: 25,
                              accessor: (match: MinimumAuditMatch) => (
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                  <LDate value={match.datetime} day="2-digit" month="2-digit" />
                                  <LTime value={match.datetime} />
                                </div>
                              ),
                            },
                            {
                              Header: $t({
                                id: 'audit.schedulesViewScreen.matchDiff',
                                defaultMessage: 'Diferencia (minutos)',
                              }),
                              align: 'center',
                              w: 20,
                              accessor: (match: MinimumAuditMatch) => Math.round(match.matchedDiff),
                            },
                            {
                              Header: $t({
                                id: 'audit.props.score',
                                defaultMessage: 'Score',
                              }),
                              align: 'center',
                              w: 15,
                              accessor: (match: MinimumAuditMatch) => (
                                <Chip size="sm" type="secondary">
                                  {match.score}
                                </Chip>
                              ),
                            },
                            {
                              Header: $t({
                                id: 'audit.props.duration',
                                defaultMessage: 'Duración reproducida',
                              }),
                              align: 'center',
                              accessor: (match: MinimumAuditMatch) => (
                                <Duration seconds={(match.playedDuration / 1000) as Seconds} />
                              ),
                            },
                          ]}
                          data={[...(schedule.matches || [])]}
                        />
                      </Box>
                    )}
                  </>
                }
              />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
